import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hideBackground", "ModalComponent"];
import styled from 'styled-components';
import UIModal from 'UIComponents/dialog/UIModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledModal = styled(props => {
  const {
      ModalComponent
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(ModalComponent, Object.assign({}, rest));
}).withConfig({
  displayName: "StyledModal",
  componentId: "sc-12b6rkp-0"
})(["&&&{background-color:", ";}"], props => props.hideBackground ? 'transparent' : undefined);
StyledModal.defaultProps = {
  ModalComponent: UIModal
};